export default __webpack_public_path__ + "static/recog-8-ce3c7c2ee69528a2c9e3274193c9b89c.webp";